var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.66654V5.83321C6.66667 3.99226 8.15905 2.49988 10 2.49988C11.8409 2.49988 13.3333 3.99226 13.3333 5.83321V6.66654M2.5 9.99988L9.3231 13.0324C9.75404 13.2239 10.246 13.2239 10.6769 13.0324L17.5 9.99988M5.16667 17.4999H14.8333C15.7668 17.4999 16.2335 17.4999 16.59 17.3182C16.9036 17.1584 17.1586 16.9035 17.3183 16.5899C17.5 16.2333 17.5 15.7666 17.5 14.8332V9.33321C17.5 8.39979 17.5 7.93308 17.3183 7.57656C17.1586 7.26296 16.9036 7.00799 16.59 6.8482C16.2335 6.66654 15.7668 6.66654 14.8333 6.66654H5.16667C4.23325 6.66654 3.76654 6.66654 3.41002 6.8482C3.09641 7.00799 2.84144 7.26296 2.68166 7.57656C2.5 7.93308 2.5 8.39979 2.5 9.33321V14.8332C2.5 15.7666 2.5 16.2333 2.68166 16.5899C2.84144 16.9035 3.09641 17.1584 3.41002 17.3182C3.76654 17.4999 4.23325 17.4999 5.16667 17.4999Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.9c6d18c74665273930906a81f85c0d34.svg";
export { ForwardRef as ReactComponent };